@if (!isLoaded()) {
  <div class="loading">
    <nz-spin nzSimple nzSize="large" nzTip="Ładowanie danych ..." />
  </div>
} @else {
  @if (hasAdditionalCriteria()) {
    <nz-card class="meta-card" [nzBordered]="false">
      <div class="card-section-header">
        <span nz-icon nzType="tags"></span>
        <span>Dodatkowe kryterium NFZ</span>
      </div>
      <form nz-form nzLayout="vertical" class="create-form">
        <div class="criteria-list">
          @for (criterion of nhfCodeAdditionalCriterial(); track criterion.code) {
            <label
              class="criterion-checkbox"
              nz-checkbox
              [ngModel]="isSettlementSelected(criterion.code!)"
              (ngModelChange)="settlementSelectionChange(criterion.code!, $event)"
              [name]="'criterion-' + criterion.code"
            >
              <span class="criterion-code">{{ criterion.code }}</span>
              {{ criterion.name }}
            </label>
          }
        </div>
      </form>
    </nz-card>
    <div class="button-footer-wrapper">
      <button
        nz-button
        nzType="primary"
        (click)="submit()"
        [nzLoading]="isLoading()"
        [disabled]="isLoading()"
      >
        <span nz-icon nzType="edit"></span>
        Zapisz kryteria
      </button>
    </div>
  }
}
